// pages/ai-events/AIAssistantPage.tsx

import React, { useState, useEffect } from 'react';
import { useAISession } from '@/hooks/useAISession';
import { toast } from 'sonner';

const AIAssistantPage = () => {
  const { currentSession, messages, create, send, isLoadingMessages } = useAISession();
  const [input, setInput] = useState('');
  const [isSending, setIsSending] = useState(false);

  // Create session on mount if none exists
  useEffect(() => {
    if (!currentSession) {
      create('Event Planning Assistant');
    }
  }, []);

  const handleSend = async () => {
    if (!input.trim() || !currentSession) return;

    setIsSending(true);
    try {
      await send(input);
      setInput('');
    } catch (error) {
      toast.error('Failed to send message');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="container mx-auto p-6 max-w-4xl h-screen flex flex-col">
      <h1 className="text-2xl font-bold mb-4">🤖 AI Event Planning Assistant</h1>

      {/* Messages */}
      <div className="flex-1 bg-white rounded-lg shadow overflow-y-auto p-4 mb-4 space-y-4">
        {isLoadingMessages && <p className="text-gray-500">Loading messages...</p>}
        
        {messages.map((message) => (
          <div
            key={message.id}
            className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[70%] p-3 rounded-lg ${
                message.role === 'user'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-900'
              }`}
            >
              <p className="whitespace-pre-wrap">{message.content}</p>
              <p className="text-xs mt-1 opacity-70">
                {new Date(message.createdAt).toLocaleTimeString()}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="flex gap-2">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSend()}
          placeholder="Ask me to generate an event..."
          className="flex-1 p-3 border rounded-lg"
          disabled={isSending}
        />
        <button
          onClick={handleSend}
          disabled={isSending || !input.trim()}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 disabled:opacity-50"
        >
          {isSending ? '...' : 'Send'}
        </button>
      </div>
    </div>
  );
};

export default AIAssistantPage;
